var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDjango(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "326px",
    viewBox: "0 0 256 326",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#2BA977"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.78426,0 L168.062259,0 L168.062259,244.191113 C140.771855,249.353285 120.681181,251.384192 98.944855,251.384192 C33.8730137,251.316268 0,222.24509 0,166.412124 C0,112.616857 35.9300792,77.7042732 91.6079875,77.7042732 C100.247663,77.7042732 106.830273,78.3835061 114.78426,80.4212057 L114.78426,0 Z M116.651443,124.426648 C110.411677,122.388948 105.269013,121.709714 98.6864035,121.709714 C71.7388438,121.709714 56.1737143,138.147157 56.1737143,166.953436 C56.1737143,194.998972 71.0531556,210.485489 98.3435585,210.485489 C104.24048,210.485489 109.040299,210.152664 116.651443,209.133814 L116.651443,124.426648 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.186899,84.2605714 L255.186899,206.52254 C255.186899,248.628204 252.032731,268.876144 242.775936,286.332436 C234.136261,303.116288 222.753832,313.698741 199.234715,325.388343 L149.796571,302.090646 C173.315688,291.161784 184.698118,281.503088 191.966417,266.763729 C199.577559,251.691545 201.977469,234.235253 201.977469,188.319092 L201.977469,84.2605714 L255.186899,84.2605714 L255.186899,84.2605714 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.608,0 L249.885999,0 L249.885999,54.1348831 L196.608,54.1348831 L196.608,0 L196.608,0 Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDjango);
export default __webpack_public_path__ + "static/media/django.c340192e9b922803496727865292d17f.svg";
export { ForwardRef as ReactComponent };